var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("ContentLayout", {
    attrs: {
      title: _vm.iSEdited
        ? _vm.$t("label_essweb_customForm_form_editTitle")
        : _vm.$t("label_essweb_customForm_form_viewTitle"),
      pad: "0",
      delBtn: _vm.hasBtn("delete-admin-custom-form-type"),
      widthClass: "max-1000",
      initData: _vm.customFormData,
      checkData: [
        "application_type_name",
        "type_code",
        "application_type_desc",
        "flow_template_uuid",
        "color_code",
        "sequence",
      ],
      editBtn: !_vm.iSEdited && _vm.hasBtn("edit-admin-custom-form-type"),
    },
    on: {
      change: function (changed) {
        return (_vm.isChanged = changed)
      },
      edit: function ($event) {
        _vm.iSEdited = true
      },
      delete: function ($event) {
        _vm
          .$confirmDo(_vm.$t("label_essweb_customForm_lsit_title"))
          .then(function (res) {
            res ? _vm.toDelete() : null
          })
      },
    },
    scopedSlots: _vm._u([
      {
        key: "page-main",
        fn: function () {
          return [
            _c("Taber", {
              attrs: { curTab: _vm.curTab, items: _vm.taber },
              on: {
                change: function (tab) {
                  return (_vm.curTab = tab)
                },
              },
              scopedSlots: _vm._u([
                {
                  key: "content-1",
                  fn: function () {
                    return [
                      _c(
                        "v-form",
                        { ref: "form", attrs: { "lazy-validation": "" } },
                        [
                          _c(
                            "v-row",
                            [
                              _c(
                                "v-col",
                                {
                                  attrs: {
                                    xs: "12",
                                    sm: "12",
                                    md: "12",
                                    lg: "12",
                                    cols: "12",
                                  },
                                },
                                [
                                  _c("v-switch", {
                                    staticClass: "ml-4",
                                    attrs: {
                                      color: "primary",
                                      disabled: !_vm.iSEdited,
                                      label: _vm.customFormData.status
                                        ? _vm.$t(
                                            "label_essweb_customForm_form_activeLabel"
                                          )
                                        : "",
                                    },
                                    model: {
                                      value: _vm.customFormData.status,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.customFormData,
                                          "status",
                                          $$v
                                        )
                                      },
                                      expression: "customFormData.status",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                "v-col",
                                {
                                  attrs: {
                                    xs: "12",
                                    sm: "12",
                                    md: "8",
                                    lg: "8",
                                    cols: "12",
                                  },
                                },
                                [
                                  _c("inputTextFiledMultiLang", {
                                    attrs: {
                                      bindData:
                                        _vm.customFormData
                                          .application_type_name,
                                      maxlength: "100",
                                      readonly: !_vm.iSEdited,
                                      filled: _vm.iSEdited,
                                      label: _vm.$t(
                                        "label_essweb_customForm_form_customFormNameLabel"
                                      ),
                                      rules: _vm.$GetRules(
                                        ["_Require_Rules"],
                                        [null]
                                      ),
                                    },
                                    on: {
                                      change: function (valueArr) {
                                        _vm.customFormData.application_type_name =
                                          valueArr
                                      },
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                "v-col",
                                {
                                  attrs: {
                                    xs: "12",
                                    sm: "12",
                                    md: "4",
                                    lg: "4",
                                    cols: "12",
                                  },
                                },
                                [
                                  _c("normalInputTextFiled", {
                                    attrs: {
                                      label: _vm.$t(
                                        "label_essweb_customForm_form_customFormCodeLabel"
                                      ),
                                      readonly: !_vm.iSEdited,
                                      filled: _vm.iSEdited,
                                      maxlength: "100",
                                      rules: _vm.$GetRules(
                                        ["_Require_Rules", "_Length_Rules"],
                                        [null, 100]
                                      ),
                                    },
                                    model: {
                                      value: _vm.customFormData.type_code,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.customFormData,
                                          "type_code",
                                          $$v
                                        )
                                      },
                                      expression: "customFormData.type_code",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                "v-col",
                                {
                                  attrs: {
                                    xs: "12",
                                    sm: "12",
                                    md: "12",
                                    lg: "12",
                                    cols: "12",
                                  },
                                },
                                [
                                  _c("inputTextFiledMultiLang", {
                                    attrs: {
                                      bindData:
                                        _vm.customFormData
                                          .application_type_desc,
                                      maxlength: "100",
                                      readonly: !_vm.iSEdited,
                                      filled: _vm.iSEdited,
                                      label: _vm.$t(
                                        "label_essweb_customForm_form_customFormDescLabel"
                                      ),
                                    },
                                    on: {
                                      change: function (valueArr) {
                                        _vm.customFormData.application_type_desc =
                                          valueArr
                                      },
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                "v-col",
                                {
                                  attrs: {
                                    xs: "12",
                                    sm: "12",
                                    md: "8",
                                    lg: "8",
                                    cols: "12",
                                  },
                                },
                                [
                                  _c(
                                    "v-sheet",
                                    {
                                      staticClass:
                                        "mrc_text_require text--secondary",
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t(
                                            "label_essweb_customForm_form_customFormApprovalFlowLabel"
                                          )
                                        )
                                      ),
                                    ]
                                  ),
                                  _c("v-autocomplete", {
                                    attrs: {
                                      readonly: !_vm.iSEdited,
                                      filled: _vm.iSEdited,
                                      items: _vm.approvalFlows,
                                      "append-icon": _vm.iSEdited
                                        ? "keyboard_arrow_down"
                                        : "",
                                      "item-text": "view_fields",
                                      "item-value": "value_field",
                                      "single-line": "",
                                      rules: _vm.$GetRules(
                                        ["_Require_Rules"],
                                        [null]
                                      ),
                                      "menu-props": {
                                        offsetY: true,
                                        transition: "slide-y-transition",
                                        rounded: true,
                                        contentClass: "elevation-4",
                                      },
                                      label: _vm.$t(
                                        "label_essweb_customForm_form_customFormApprovalFlowLabel"
                                      ),
                                      dense: "",
                                    },
                                    scopedSlots: _vm._u([
                                      {
                                        key: "no-data",
                                        fn: function () {
                                          return [_c("noContent")]
                                        },
                                        proxy: true,
                                      },
                                    ]),
                                    model: {
                                      value:
                                        _vm.customFormData.flow_template_uuid,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.customFormData,
                                          "flow_template_uuid",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "customFormData.flow_template_uuid",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                "v-col",
                                {
                                  attrs: {
                                    xs: "12",
                                    sm: "12",
                                    md: "4",
                                    lg: "4",
                                    cols: "12",
                                  },
                                },
                                [
                                  _c(
                                    "v-sheet",
                                    {
                                      staticClass:
                                        "mrc_text_require text--secondary",
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t(
                                            "label_essweb_customForm_form_colorLabel"
                                          )
                                        )
                                      ),
                                    ]
                                  ),
                                  _c("SelectColor", {
                                    attrs: {
                                      readonly: !_vm.iSEdited,
                                      filled: _vm.iSEdited,
                                      items: _vm.$Colors,
                                      rules: _vm.$GetRules(
                                        ["_Require_Rules"],
                                        [null]
                                      ),
                                    },
                                    model: {
                                      value: _vm.customFormData.color_code,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.customFormData,
                                          "color_code",
                                          $$v
                                        )
                                      },
                                      expression: "customFormData.color_code",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                "v-col",
                                {
                                  attrs: {
                                    xs: "12",
                                    sm: "12",
                                    md: "12",
                                    lg: "12",
                                    cols: "12",
                                  },
                                },
                                [
                                  _c("numberInputTextFiled", {
                                    attrs: {
                                      readonly: !_vm.iSEdited,
                                      filled: _vm.iSEdited,
                                      rules: _vm.$GetRules(
                                        ["_Number_negative", "_Length_Rules"],
                                        [null, 15]
                                      ),
                                      label: _vm.$t(
                                        "label_essweb_customForm_form_sequenceLabel"
                                      ),
                                      isNotRequire: "",
                                    },
                                    model: {
                                      value: _vm.customFormData.sequence,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.customFormData,
                                          "sequence",
                                          $$v
                                        )
                                      },
                                      expression: "customFormData.sequence",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                "v-col",
                                {
                                  attrs: {
                                    xs: "12",
                                    sm: "12",
                                    md: "12",
                                    lg: "12",
                                    cols: "12",
                                  },
                                },
                                [
                                  _c(
                                    "v-sheet",
                                    { staticClass: "text--secondary" },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t(
                                            "label_essweb_customForm_form_remarkLabel"
                                          )
                                        )
                                      ),
                                    ]
                                  ),
                                  _c("v-textarea", {
                                    attrs: {
                                      rows: "5",
                                      "no-resize": "",
                                      readonly: !_vm.iSEdited,
                                      filled: _vm.iSEdited,
                                      maxlength: "500",
                                      dense: "",
                                      counter: "500",
                                      "single-line": "",
                                    },
                                    model: {
                                      value: _vm.customFormData.remarks,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.customFormData,
                                          "remarks",
                                          $$v
                                        )
                                      },
                                      expression: "customFormData.remarks",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ]
                  },
                  proxy: true,
                },
                {
                  key: "content-2",
                  fn: function () {
                    return [
                      _c(
                        "v-container",
                        {
                          staticClass: "mrc-grey rounded-lg",
                          attrs: { fluid: "" },
                        },
                        _vm._l(_vm.NoticeList, function (item, index) {
                          return _c(
                            "v-sheet",
                            {
                              key: index,
                              staticClass:
                                "transparent d-flex pa-0 my-3 align-center",
                            },
                            [
                              _c("v-hover", {
                                attrs: { "open-delay": "100" },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function (ref) {
                                        var hover = ref.hover
                                        return [
                                          _c(
                                            "v-card",
                                            {
                                              staticClass:
                                                "\n                  white\n                  d-flex\n                  flex-row\n                  justify-space-around\n                  flex-grow-1\n                  ml-3\n                  pa-2\n                  align-center\n                ",
                                              attrs: {
                                                height: "60",
                                                elevation: hover ? 10 : 2,
                                              },
                                            },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticStyle: {
                                                    width: "20px",
                                                  },
                                                },
                                                [
                                                  _c("svg-icon", {
                                                    attrs: {
                                                      size: "24",
                                                      fill: "black",
                                                      iconClass:
                                                        "LabeledColour",
                                                    },
                                                  }),
                                                ],
                                                1
                                              ),
                                              _c(
                                                "span",
                                                { staticClass: "ml-2" },
                                                [
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(
                                                        _vm.$getCommonLangValue(
                                                          item[
                                                            "application_type_notice_point_" +
                                                              item.number
                                                          ]
                                                        )
                                                      ) +
                                                      " "
                                                  ),
                                                ]
                                              ),
                                              _c("v-spacer"),
                                              _c(
                                                "div",
                                                [
                                                  hover && _vm.iSEdited
                                                    ? _c(
                                                        "v-btn",
                                                        {
                                                          staticClass: "ma-2",
                                                          attrs: {
                                                            icon: "",
                                                            "x-small": "",
                                                          },
                                                          on: {
                                                            click: function (
                                                              $event
                                                            ) {
                                                              return _vm.toEditNotice(
                                                                item
                                                              )
                                                            },
                                                          },
                                                        },
                                                        [
                                                          _c(
                                                            "span",
                                                            {
                                                              staticClass:
                                                                "material-icons-round",
                                                            },
                                                            [_vm._v("edit")]
                                                          ),
                                                        ]
                                                      )
                                                    : _vm._e(),
                                                  hover && _vm.iSEdited
                                                    ? _c(
                                                        "v-btn",
                                                        {
                                                          staticClass: "ma-2",
                                                          attrs: { icon: "" },
                                                          on: {
                                                            click: function (
                                                              $event
                                                            ) {
                                                              return _vm.onDeleteNotice(
                                                                item
                                                              )
                                                            },
                                                          },
                                                        },
                                                        [
                                                          _c(
                                                            "span",
                                                            {
                                                              staticClass:
                                                                "material-icons-round",
                                                            },
                                                            [_vm._v("delete")]
                                                          ),
                                                        ]
                                                      )
                                                    : _vm._e(),
                                                ],
                                                1
                                              ),
                                            ],
                                            1
                                          ),
                                        ]
                                      },
                                    },
                                  ],
                                  null,
                                  true
                                ),
                              }),
                            ],
                            1
                          )
                        }),
                        1
                      ),
                    ]
                  },
                  proxy: true,
                },
                {
                  key: "content-3",
                  fn: function () {
                    return [
                      _c("Tabler", {
                        attrs: {
                          headers: _vm.headers,
                          items: _vm.desserts,
                          border: "",
                          avPerPage: 50,
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "item.sequence",
                            fn: function (ref) {
                              var item = ref.item
                              return [_vm._v(" " + _vm._s(item.sequence) + " ")]
                            },
                          },
                          {
                            key: "item.label",
                            fn: function (ref) {
                              var item = ref.item
                              return [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm.$getCommonLangValue(
                                        item.custom_field_name
                                      )
                                    ) +
                                    " "
                                ),
                              ]
                            },
                          },
                          {
                            key: "item.type",
                            fn: function (ref) {
                              var item = ref.item
                              return [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm.$getCommonLangValue(
                                        item.custom_field_data_type_name
                                      )
                                    ) +
                                    " "
                                ),
                              ]
                            },
                          },
                          {
                            key: "item.mandatory",
                            fn: function (ref) {
                              var item = ref.item
                              return [
                                Number(item.is_required)
                                  ? _c(
                                      "span",
                                      { staticClass: "material-icons-round" },
                                      [_vm._v("check")]
                                    )
                                  : _c(
                                      "span",
                                      { staticClass: "material-icons-round" },
                                      [_vm._v("close")]
                                    ),
                              ]
                            },
                          },
                          {
                            key: "item.action",
                            fn: function (ref) {
                              var item = ref.item
                              return [
                                _c(
                                  "div",
                                  [
                                    _vm.iSEdited
                                      ? _c(
                                          "v-btn",
                                          {
                                            staticClass: "ma-2",
                                            attrs: { icon: "", "x-small": "" },
                                            on: {
                                              click: function ($event) {
                                                _vm.curItemUuid = item.uuid
                                                _vm.showEditItem = true
                                              },
                                            },
                                          },
                                          [
                                            _c(
                                              "span",
                                              {
                                                staticClass:
                                                  "material-icons-round",
                                              },
                                              [_vm._v("edit")]
                                            ),
                                          ]
                                        )
                                      : _vm._e(),
                                    _vm.iSEdited
                                      ? _c(
                                          "v-btn",
                                          {
                                            staticClass: "ma-2",
                                            attrs: { icon: "" },
                                            on: {
                                              click: function ($event) {
                                                return _vm.toDeleteItem(
                                                  item.uuid
                                                )
                                              },
                                            },
                                          },
                                          [
                                            _c(
                                              "span",
                                              {
                                                staticClass:
                                                  "material-icons-round",
                                              },
                                              [_vm._v("delete")]
                                            ),
                                          ]
                                        )
                                      : _vm._e(),
                                  ],
                                  1
                                ),
                              ]
                            },
                          },
                          {
                            key: "footer",
                            fn: function () {
                              return [
                                _c(
                                  "v-container",
                                  { staticClass: "pa-0", attrs: { fluid: "" } },
                                  [
                                    _c("v-divider"),
                                    _vm.iSEdited
                                      ? _c(
                                          "v-btn",
                                          {
                                            staticClass: "my-2 text-capitalize",
                                            attrs: {
                                              text: "",
                                              small: "",
                                              color: "primary",
                                            },
                                            on: {
                                              click: function ($event) {
                                                _vm.showNewItem = true
                                              },
                                            },
                                          },
                                          [
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  _vm.$t(
                                                    "label_essweb_customForm_form_newItemLabel"
                                                  )
                                                ) +
                                                " "
                                            ),
                                            _c(
                                              "span",
                                              {
                                                staticClass:
                                                  "material-icons-round",
                                              },
                                              [_vm._v("add")]
                                            ),
                                          ]
                                        )
                                      : _vm._e(),
                                  ],
                                  1
                                ),
                              ]
                            },
                            proxy: true,
                          },
                        ]),
                      }),
                    ]
                  },
                  proxy: true,
                },
              ]),
            }),
          ]
        },
        proxy: true,
      },
      {
        key: "page-actions",
        fn: function () {
          return [
            _vm.iSEdited && _vm.curTab == "tab-1"
              ? _c("CardActions", {
                  attrs: { saveBtn: _vm.curTab == "tab-1" },
                  on: {
                    save: _vm.toSave,
                    cancel: function ($event) {
                      return _vm.toBack(_vm.isChanged)
                    },
                  },
                })
              : _vm._e(),
          ]
        },
        proxy: true,
      },
      {
        key: "tools-main",
        fn: function () {
          return [
            _c("editNotice", {
              attrs: {
                show: _vm.showEditNotice,
                PropertyData: _vm.NoticePropertyData,
              },
              on: {
                close: function ($event) {
                  _vm.showEditNotice = false
                  _vm.NoticePropertyData = null
                },
                onEdit: _vm.onEditNotice,
              },
            }),
            _c("newItem", {
              attrs: { show: _vm.showNewItem },
              on: {
                close: function ($event) {
                  _vm.showNewItem = false
                },
                onNew: _vm.onNewItem,
              },
            }),
            _c("editItem", {
              attrs: { show: _vm.showEditItem, curUuid: _vm.curItemUuid },
              on: {
                close: function ($event) {
                  _vm.showEditItem = false
                  _vm.curItemUuid = null
                },
                onEdit: _vm.onEditItem,
              },
            }),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }